import { DeviceVariantType } from '@unifyapps/defs/types/deviceVariant';
import { NavigationResolution } from '@unifyapps/defs/types/interface';
import { BREAKPOINT_CONFIG } from '@unifyapps/hooks/useScreen/const';
import { InterfaceModes } from '../stores/InterfaceStore/types';

/**
 * Why need to detect touch device?
 * There may be a situation where a user is on laptop that doesnt
 * have touch, but falls in tablet resolution due to screen size.
 * Therefore also check if touch present, if present , consider it as tablet resolution or else
 * desktop resolution.
 */
export const isTouchDevice = (): boolean => {
  if (typeof window === 'undefined') {
    return false;
  }

  return (
    navigator.maxTouchPoints > 0 ||
    'ontouchstart' in window ||
    // oxlint-disable-next-line no-explicit-any
    (navigator as any).msMaxTouchPoints > 0
  );
};

/**
 * To decide which navigation bar to show based on the screen width.
 * Read the screen width from the resize observer in useInterfaceResolution hook and use the
 * breakpoint config to decide the resolution.
 */
export const getBreakpoint = (width: number, mode?: InterfaceModes): NavigationResolution => {
  const breakpoint = BREAKPOINT_CONFIG.find((config) =>
    config.minWidth ? width >= config.minWidth : true,
  );

  const resolution =
    (breakpoint?.const as NavigationResolution | undefined) || NavigationResolution.SM;

  if (mode !== InterfaceModes.RUNNER) return resolution;

  const isTabletResolution =
    resolution === NavigationResolution.MD || resolution === NavigationResolution.LG;
  const isTouchPresent = isTouchDevice();

  if (isTabletResolution && !isTouchPresent) return NavigationResolution.XL;

  return resolution;
};

export const getResolutionByDevice = (
  device: DeviceVariantType,
  mode?: InterfaceModes,
): NavigationResolution => {
  switch (device) {
    case DeviceVariantType.MOBILE:
      return NavigationResolution.SM;
    case DeviceVariantType.TABLET: {
      if (mode !== InterfaceModes.RUNNER) return NavigationResolution.MD;

      const isTouchPresent = isTouchDevice();

      // If touch is not present, it means that user in on Tablet Resolution on Desktop device.
      return isTouchPresent ? NavigationResolution.MD : NavigationResolution.XL;
    }
    case DeviceVariantType.DESKTOP:
      return NavigationResolution.XL;
  }
};
